import React, { FC } from "react"
import L10n from "../../../lib/carrot-l10n"
import { Spacer } from "../atoms/Atoms"
import { useFormContext } from "react-hook-form"
import { FormAccordionSingleSelect } from "../atoms/forms/FormAccordionSingleSelect"
import FieldNames from "../../../utils/FieldNames"
import { Modal } from "../modal/Modal"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type SelectWithTitleProps = {
  reimbursementJourneys: any
}
const name = FieldNames.REIMBURSEMENT_TYPE.valueOf()

const SelectWithTitle: FC<SelectWithTitleProps> = ({ reimbursementJourneys }) => {
  const { register } = useFormContext()
  return (
    <>
      <div className="pl45-ns pl35-s pr5">
        <H2>{l`Which journey are you on?`}</H2>
      </div>
      <Spacer height={2} />
      <FormAccordionSingleSelect name={name} options={reimbursementJourneys} ref={register({ required: true })} />
    </>
  )
}
type ReimbursementsModalProps = {
  reimbursementJourneys: any
  onClose: () => void
  onSubmit: () => Promise<void>
}

const ReimbursementsModal: FC<ReimbursementsModalProps> = ({ reimbursementJourneys, onClose, onSubmit }) => {
  const {
    formState: { isValid }
  } = useFormContext()

  return (
    <form onSubmit={onSubmit}>
      <Modal titleText={l`Which journey are you on?`} onExit={onClose}>
        <div className="w-100">
          <SelectWithTitle reimbursementJourneys={reimbursementJourneys} />
          <div className="tr pr35-s pr45-ns pv35-s pv45-ns">
            <ButtonPrimary id="form-accordion-single-select-button" enabled={isValid} onClick={onSubmit} type="submit">
              {l`Next`}
            </ButtonPrimary>
          </div>
        </div>
      </Modal>
    </form>
  )
}

export default ReimbursementsModal
